var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 vis-base-grid"},[_c('DxDataGrid',{staticClass:"h-100",attrs:{"data-source":_vm.dataSource,"show-borders":true,"rowAlternationEnabled":true,"focused-row-enabled":true,"on-initialized":_vm.onInitialized,"on-selection-changed":_vm.onSelectionChange,"on-row-dbl-click":_vm.onDblClick,"selection":_vm.selection,"paging":{
      pageSize: 50,
      enabled: true,
    },"pager":{
      visible: true,
      showPageSizeSelector: true,
      showInfo: true,
    },"scrolling":{
      mode: 'standart',
      rowRenderingMode: 'standart',
    },"remote-operations":{
      paging: true,
      sorting: true,
      filtering: true,
    },"header-filter":{
      visible: true,
    },"filter-row":{
      visible: true,
    },"filter-panel":{
      visible: true,
    }}},[_c('DxColumn',{attrs:{"type":"buttons"}},[_c('DxButton',{attrs:{"hint":"DetailView","icon":"fal fa-eye","on-click":_vm.openDv}})],1),_c('DxColumn',{attrs:{"data-field":"ID","width":"100","caption":'TrackerID'}}),_c('DxColumn',{attrs:{"data-field":"TerminalID","caption":this.$t('gisTrackerList.columns.terminalId')}}),_c('DxColumn',{attrs:{"data-field":"Title","caption":this.$t('gisTrackerList.columns.title')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }